import {NodeCategoryName, NodeDefinition, nodeDefinitionList} from '../config/nodeDefinitions';
import {getNodeOutputs, NodeOutput} from '../config/nodeOutputs';

export interface AgentCatalogEntry extends NodeDefinition {
    outputs: NodeOutput[];
}

const CATEGORY_ORDER: NodeCategoryName[] = ['Triggers', 'Actions', 'Logic', 'End'];

const compareLabels = (a: string, b: string): number => (a < b ? -1 : a > b ? 1 : 0);

/**
 * Sent with every request, sorted by category then label so it serialises identically. catalog.snapshot.json
 * is this output (checked by catalog.test.ts, copied by the API's evaluation harness).
 */
export const agentCatalog = (): AgentCatalogEntry[] => nodeDefinitionList
    .map(definition => ({...definition, outputs: getNodeOutputs(definition.type)}))
    .sort((a, b) => CATEGORY_ORDER.indexOf(a.category) - CATEGORY_ORDER.indexOf(b.category) || compareLabels(a.label, b.label));
